var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('navbar-vue'),_c('div',{staticClass:"col-3 sidebarungu"},[_c('navdraw-vue')],1),_c('div',{staticClass:"col-9 p-0"},[_vm._t("default")],2),_c('div',{staticClass:"d-flex"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }